<script>
    import { formatTitle } from '../utils/utils';
    export let movilTitle;
</script>

<div class="plan-card__service plan-card__service--mobile">
    <svg class="plan-card__icon">
        <use xlink:href="/assets/img/icons/symbol-defs.svg#icon-smartphone"
        ></use>
    </svg>
    <p class="plan-card__text">
        {formatTitle(movilTitle)}<br />
        <span>izzi móvil</span>
    </p>
</div>
